import React from 'react'
import PropTypes from 'prop-types'
import {Box, InputRightElement, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {CheckIcon, InfoIcon} from '../icons'
import InfoPopover from '../popovers/info-popover'
import PhoneInput from 'react-phone-input-2'
import {useLocaleCountry} from '../../hooks/use-locale-custom'

const PhoneComponent = React.forwardRef((props, ref) => {
    const {
        isSuccess,
        isInvalid,
        tooltip,
        tooltipVariant,
        tooltipOpensOn,
        isProductRegistration,
        name,
        shouldRemoveLabel,
        value,
        rules,
        variant,
        hideSuccessIcon,
        placeholder = '',
        isDisabled,
        inputProps,
        onChange,
    } = props

    const status = isDisabled
        ? 'disabled'
        : isInvalid
        ? 'invalid'
        : isSuccess
        ? 'success'
        : undefined

    const styles = useMultiStyleConfig('Field', {
        variant: status,
        shouldRemoveLabel,
        isProductRegistration,
        isInitial: !!value,
    })

    const country = useLocaleCountry().toLowerCase()

    return (
        <Box __css={styles.container}>
            <PhoneInput
                {...(!value ? {country} : {})}
                value={value}
                onChange={(value) => onChange(`+${value}`)}
                placeholder={placeholder}
                inputProps={{
                    ...inputProps,
                    id: name,
                    name,
                    ref,
                    required: rules?.required,
                }}
            />
            <Text as="label" htmlFor={name} className="chakra-form__label" {...styles.label}>
                {props.label}
                {variant !== 'productRegistration' && rules?.required && ' *'}
            </Text>
            {status === 'success' && (
                <InputRightElement {...styles.inputRightElement}>
                    <CheckIcon
                        {...{...styles.successIcon, display: hideSuccessIcon ? 'none' : 'block'}}
                    />
                </InputRightElement>
            )}
            {tooltip && (
                <InputRightElement {...styles.inputRightElement}>
                    <InfoPopover
                        trigger={
                            <Box>
                                <InfoIcon {...styles.infoIcon} />
                            </Box>
                        }
                        variant={tooltipVariant}
                        openTooltipOn={tooltipOpensOn}
                    />
                </InputRightElement>
            )}
        </Box>
    )
})

PhoneComponent.displayName = 'PhoneComponent'
PhoneComponent.propTypes = {
    label: PropTypes.string,
    inputProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    isDisabled: PropTypes.bool,
    isInvalid: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipVariant: PropTypes.string,
    tooltipOpensOn: PropTypes.string,
    isSuccess: PropTypes.bool,
    isRequired: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    variant: PropTypes.string,
    shouldRemoveLabel: PropTypes.bool,
    value: PropTypes.string,
    rules: PropTypes.object,
    isProductRegistration: PropTypes.bool,
    'aria-label': PropTypes.string,
    borderColor: PropTypes.string,
    hideSuccessIcon: PropTypes.bool,
    type: PropTypes.string,
}

export default PhoneComponent
